var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"licenceReportView",attrs:{"title":_vm.$t('softwareComponent.licencesReport'),"icon":"id-card-alt"}},[_c('LicenceReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }